module.exports = __webpack_public_path__ + "b96b17fe07ed2bb45a6d21f388da4f1e.svg";


//////////////////
// WEBPACK FOOTER
// ./images/archive-icon-copy.svg
// module id = 81
// module chunks = 0